import RestService from '../../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

const state = {
  isLoggedIn: localStorage.getItem('token') ? true : false,
  user: JSON.parse(localStorage.getItem('user')),
  token: localStorage.getItem('token'),
  access: JSON.parse(localStorage.getItem('access'))
};

const actions = {
  login({ commit }, creds) {
    return new Promise((resolve, reject) => {
      service
        .login(creds)
        .then(response => {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.body[0]));
          localStorage.setItem('access', JSON.stringify(response.data.access));
          commit('loginSuccess', response.data);
          resolve(response);
        })
        .catch(error => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
	  localStorage.removeItem('access');
          commit('logout');
          reject(error);
          Sentry.captureException(error);
        });
    });
  },
  logout({ commit }) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('access');
    commit('logout');
  },
  setToken({ commit }, token) {
    localStorage.setItem('token', token);
    commit('setToken', token);
  }
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  user: state => state.user,
  token: state => state.token,
  access: state => state.access
};

const mutations = {
  login(state) {
    state.pending = true;
  },
  loginSuccess(state, data) {
    state.isLoggedIn = true;
    state.pending = false;
    state.user = data.body[0];
    state.token = data.token;
    state.access = data.access;
  },
  logout(state) {
    state.isLoggedIn = false;
    state.user = '';
  },
  setToken(state, token) {
    state.token = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
